import React from 'react';
import PropTypes from 'prop-types';
import { modal } from './modal/ModalEmitter';
import ChangeLog from './ChangeLog';

const Footer = ({ show = true }) => {
  const showAbout = () => {
    modal.info({ title: 'About', message: <ChangeLog />, style: 'center', render: 'about', size: 'lg' });
  };

  if (!show) {
    return null;
  }

  return (
    <div id="footer">
      <div className="footer-items">
        <div className="copyright">
          <div className="d-none d-sm-block">
            Copyright &copy; 2016 - {new Date().getFullYear()} <strong>DSI Solutions</strong>, All rights reserved.
          </div>
          <div className="d-block d-sm-none">
            &copy; {new Date().getFullYear()} <strong>DSI Solutions</strong>
          </div>
        </div>
        <div className="company-links">
          <a style={{ cursor: 'pointer' }} onClick={() => showAbout()}>
            About
          </a>{' '}
          | <a href="https://dsisolutions.biz/contact/">Contact</a>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  show: PropTypes.bool,
};

export default Footer;
